import PendoRadioButton from '../../components/radio-button/pendo-radio-button.vue.js';
import PendoRadioGroup from '../../components/radio-group/pendo-radio-group.vue.js';
import PendoIcon from '../../components/icon/pendo-icon.vue.js';
import PendoInput from '../../components/input/pendo-input.vue.js';
import PendoLoadingIndicator from '../../components/loading-indicator/pendo-loading-indicator.vue.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import PendoAlert from '../../components/alert/pendo-alert.vue.js';
import PendoModal from '../../components/modal/pendo-modal.vue.js';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
const MIN_FAVICON_DIMENSIONS = 24;
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
const EXP_FAVICON_DIMENSIONS = 32;
var script = {
  name: 'PendoFaviconUpload',
  components: {
    PendoRadioButton,
    PendoRadioGroup,
    PendoIcon,
    PendoInput,
    PendoLoadingIndicator,
    PendoButton,
    PendoAlert,
    PendoModal
  },
  props: {
    urlFavicon: {
      type: Object,
      default: () => {}
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploadOptionValue: 'url',
      uploadOptions: [{
        value: 'url',
        label: 'By Url'
      }, {
        value: 'upload',
        label: 'Upload Image'
      }],
      urlInput: '',
      currentUrl: '',
      localFavicon: null,
      localUrlFavicon: {},
      isLoadingFavicon: false,
      file: null,
      localFaviconErr: '',
      urlError: false,
      hideFavicon: true
    };
  },
  computed: {
    showUrlFavicon() {
      return !this.isLoadingFavicon && !this.hideFavicon && this.isValidUrlFavicon && this.urlInput !== '';
    },
    hasUploadedFavicon() {
      if (this.uploadOptionValue === 'url') {
        return !this.urlError && this.isValidUrlFavicon;
      }
      return this.localFavicon !== null;
    },
    isValidUrlFavicon() {
      return this.localUrlFavicon[this.currentUrl] !== undefined && this.localUrlFavicon[this.currentUrl] !== `invalid url: ${this.currentUrl}`;
    },
    isInvalidFaviconUri() {
      return this.localUrlFavicon[this.currentUrl] === `invalid url: ${this.currentUrl}` && this.urlInput !== '';
    }
  },
  watch: {
    urlFavicon() {
      this.isLoadingFavicon = false;
      this.localUrlFavicon = this.urlFavicon;
      if (this.isInvalidFaviconUri) {
        this.urlError = true;
      }
    }
  },
  methods: {
    onUrlInput: _async(function ($event) {
      const _this = this;
      _this.isLoadingFavicon = false;
      _this.urlInput = $event;
      let preparedUrl = _this.urlInput;
      if (!_this.isValidDomain(_this.urlInput)) {
        _this.urlError = _this.urlInput !== '';
        return;
      }
      if (preparedUrl.match(/^http[s]?:\/\//) === null) {
        preparedUrl = `https://${preparedUrl}`;
      }
      const urlObj = new URL(preparedUrl);
      if (urlObj.hostname !== _this.currentUrl) {
        _this.isLoadingFavicon = true;
        _this.hideFavicon = false;
        _this.$emit('fetch-favicon', urlObj.hostname);
        _this.urlError = false;
        _this.currentUrl = urlObj.hostname;
      }
      return _await();
    }),
    resetLocalUpload() {
      this.localFavicon = null;
      this.file = null;
    },
    resetUrlUpload() {
      this.urlInput = '';
      this.currentUrl = '';
      this.isLoadingFavicon = false;
      this.urlError = false;
      this.hideFavicon = true;
    },
    uploadFavicon(event) {
      this.localFaviconErr = '';
      this.resetLocalUpload();
      this.file = event.target.files[0];
      const reader = new FileReader();
      if (this.file.size / 1024 / 1024 > 1) {
        this.localFaviconErr = 'Image Exceeds 1MB in Size';
        this.resetLocalUpload();
        return;
      }
      reader.onloadend = () => {
        const imgObject = new Image();
        imgObject.onload = () => {
          const tempImg = {
            imgURI: reader.result,
            width: imgObject.width,
            height: imgObject.height
          };
          if (tempImg.width < MIN_FAVICON_DIMENSIONS || tempImg.height < MIN_FAVICON_DIMENSIONS) {
            this.localFaviconErr = `Image ${tempImg.width > MIN_FAVICON_DIMENSIONS ? 'Width' : 'Height'} is smaller than ${MIN_FAVICON_DIMENSIONS}px`;
            this.resetLocalUpload();
            return;
          }
          if (tempImg.width !== EXP_FAVICON_DIMENSIONS || tempImg.height !== EXP_FAVICON_DIMENSIONS) {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.width = 32;
            canvas.height = 32;
            context.drawImage(imgObject, 0, 0, canvas.width, canvas.height);
            tempImg.imgURI = canvas.toDataURL(imgObject.type);
            tempImg.height = 32;
            tempImg.width = 32;
          }
          this.localFavicon = tempImg;
        };
        imgObject.src = reader.result;
      };
      reader.readAsDataURL(this.file);
    },
    chooseFile() {
      this.$refs.fileInput.value = null;
      this.$refs.fileInput.click();
    },
    isValidDomain(domain) {
      if (domain === '') {
        this.resetUrlUpload();
        return false;
      }
      const strippedDomain = domain.replace(/^http[s]?:\/\//, '');
      const validDomainRegex = new RegExp('^([a-z0-9]+(-+[a-z0-9]+)*\\.)+[a-z]{2,}$', 'gm');
      return validDomainRegex.test(strippedDomain);
    },
    cancelUpload() {
      this.resetLocalUpload();
      this.resetUrlUpload();
      this.$emit('cancel-upload');
    },
    confirmUpload() {
      this.$emit('upload-favicon', this.uploadOptionValue === 'url' ? this.urlFavicon[Object.keys(this.urlFavicon)[0]] : this.localFavicon.imgURI);
      this.resetLocalUpload();
      this.resetUrlUpload();
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-favicon-upload.vue2.js.map
